module.exports = __webpack_public_path__ + "img/scan-qr-code.50176c93.gif";